import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Typography, Box, FormControl, Grid } from '@material-ui/core';
import { KailonaButton, KailonaTable, KailonaDateRangePicker } from '@kailona/ui';
import { Edit, Delete } from '@material-ui/icons';
import VitalsService from '../services/VitalsService';
import { Logger } from '@kailona/core';
import VitalsEditModal from './VitalsEditModal';
import GridColumn from '../lib/GridColumn';
var logger = new Logger('Vitals.VitalsDataModule');

var VitalsDataModule = /*#__PURE__*/function (_Component) {
  _inherits(VitalsDataModule, _Component);

  var _super = _createSuper(VitalsDataModule);

  function VitalsDataModule(props) {
    var _this;

    _classCallCheck(this, VitalsDataModule);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchVitals", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var filters, params, vitals;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });

              filters = _this.state.filters;
              _context.prev = 2;
              params = [{
                date: "ge".concat(moment(filters.dateRange.begin).hour(0).minute(0).second(0).utc().toISOString())
              }, {
                date: "le".concat(moment(filters.dateRange.end).hour(23).minute(59).second(59).utc().toISOString())
              }, {
                code: 'http://loinc.org|85353-1',
                _include: 'Observation:has-member',
                //_sort: '-date', // not supported with _include by ibm fhir server
                _count: _this.state.rowsPerPage
              }];
              _context.next = 6;
              return _this.vitalsService.fetchData(params);

            case 6:
              vitals = _context.sent;

              _this.setState({
                loading: false,
                data: _this.sortVitals(vitals)
              });

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              logger.error(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchNextVitals", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var nextVitals, allVitals;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.vitalsService.hasNextData) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _this.setState({
                loading: true
              });

              _context2.prev = 3;
              _context2.next = 6;
              return _this.vitalsService.fetchNextData(_this.state.data);

            case 6:
              nextVitals = _context2.sent;
              allVitals = [].concat(_toConsumableArray(_this.state.data), _toConsumableArray(nextVitals));

              _this.setState({
                loading: false,
                data: _this.sortVitals(allVitals)
              });

              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              logger.error(_context2.t0);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 11]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.fetchVitals();
    });

    _defineProperty(_assertThisInitialized(_this), "filterByDateRange", function (dateRangeValue) {
      var filters = _this.state.filters;
      filters.dateRange = dateRangeValue;

      _this.setState({
        filters: filters
      }, function () {
        _this.fetchVitals();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSave", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(vitalsData) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState({
                  savingVitals: true
                });

                _context3.prev = 1;
                _context3.next = 4;
                return _this.vitalsService.upsertData(vitalsData);

              case 4:
                _this.vitalsEditModalRef.current.toggleModal(false);

                _this.fetchVitals();

                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                logger.error(_context3.t0);

              case 11:
                _this.setState({
                  savingVitals: false
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleDelete", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(vitalsData) {
        var idMap, promises;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                idMap = vitalsData.idMap;

                _this.setState({
                  savingVitals: true
                });

                promises = [];
                Object.values(idMap).forEach(function (id) {
                  var promise = _this.vitalsService.removeData(id);

                  promises.push(promise);
                });
                _context4.prev = 4;
                _context4.next = 7;
                return Promise.all(promises);

              case 7:
                _this.vitalsEditModalRef.current.toggleModal(false);

                _this.fetchVitals();

                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](4);
                logger.error(_context4.t0);

              case 14:
                _this.setState({
                  savingVitals: false
                });

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[4, 11]]);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onChangePage", function (e, page) {
      _this.setState({
        page: page
      }, function () {
        _this.fetchVitals();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeRowsPerPage", function (e) {
      var value = e.target.value;

      _this.setState({
        rowsPerPage: value
      }, function () {
        _this.fetchVitals();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddNewVitals", function () {
      _this.setState({
        vitalsDataToUpdate: null
      }, function () {
        _this.vitalsEditModalRef.current.toggleModal(true);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEditVitals", function (vitalsData) {
      _this.setState({
        vitalsDataToUpdate: vitalsData
      }, function () {
        _this.vitalsEditModalRef.current.toggleModal(true);
      });
    });

    _this.state = {
      loading: true,
      filters: {
        dateRange: {
          begin: moment().clone().subtract(1, 'month'),
          end: moment()
        }
      },
      page: 0,
      rowsPerPage: 25,
      data: [],
      columns: [{
        label: '',
        key: 'date'
      }, {
        label: t('ehr', 'Systolic Blood Pressure'),
        key: 'systolicBloodPressure'
      }, {
        label: t('ehr', 'Diastolic Blood Pressure'),
        key: 'diastolicBloodPressure'
      }, {
        label: t('ehr', 'Heart Rate'),
        key: 'heartRate'
      }, {
        label: t('ehr', 'Body Temperature'),
        key: 'bodyTemperature'
      }, {
        label: t('ehr', 'Oxygen Saturation (SpO2)'),
        key: 'oxygenSaturation'
      }],
      vitalsDataToUpdate: null,
      savingVitals: false
    };
    _this.contextMenuOptions = [{
      label: t('ehr', 'Edit'),
      icon: /*#__PURE__*/React.createElement(Edit, {
        fontSize: "small"
      }),
      onClick: _this.onEditVitals
    }, {
      label: t('ehr', 'Delete'),
      icon: /*#__PURE__*/React.createElement(Delete, {
        fontSize: "small"
      }),
      onClick: _this.handleDelete
    }];
    _this.vitalsService = new VitalsService();
    _this.vitalsEditModalRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(VitalsDataModule, [{
    key: "sortVitals",
    value: function sortVitals(vitals) {
      return vitals.sort(function (v1, v2) {
        return moment(v1.date).isSameOrAfter(moment(v2.date)) ? -1 : 1;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          filters = _this$state.filters;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', 'Vitals'))), /*#__PURE__*/React.createElement(Box, {
        className: "add-new",
        mt: 2
      }, /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Add New Vitals'),
        onClick: this.onAddNewVitals
      })), /*#__PURE__*/React.createElement(Box, {
        className: "filters",
        mt: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        justifyContent: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        style: {
          marginRight: '6px'
        }
      }, t('ehr', 'Filter by'), ":", ' ')), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateRangePicker, {
        id: "date",
        defaultValue: filters.dateRange,
        onChange: this.filterByDateRange,
        ariaLabel: t('ehr', 'Filter by date'),
        maxDate: new Date()
      })))))), /*#__PURE__*/React.createElement(Box, {
        className: "content",
        mt: 3,
        style: {
          display: 'flex',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(KailonaTable, {
        data: this.state.data,
        columns: this.state.columns,
        page: this.state.page,
        rowsPerPage: this.state.rowsPerPage,
        onChangePage: this.onChangePage,
        onChangeRowsPerPage: this.onChangeRowsPerPage,
        contextMenu: this.contextMenuOptions,
        onEdit: this.onEditVitals,
        loading: loading,
        fetchNewData: this.fetchNextVitals
      })), /*#__PURE__*/React.createElement(VitalsEditModal, {
        ref: this.vitalsEditModalRef,
        vitalsData: this.state.vitalsDataToUpdate,
        handleSave: this.handleSave,
        savingVitals: this.state.savingVitals
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return VitalsDataModule;
}(Component);

export { VitalsDataModule as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/components/VitalsDataModule.js");
  reactHotLoader.register(VitalsDataModule, "VitalsDataModule", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/components/VitalsDataModule.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();